import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import profileImage from '../styles/임현우_증명사진.jpeg';

const About: React.FC = () => {
  const { t, language } = useLanguage();
  return (
    <section id="about" className="py-20 px-6">
      <div className="container mx-auto max-w-4xl">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-4xl font-bold mb-8 text-center">
            <span className="text-gradient">{t('about.title')}</span>
          </h2>
          
          <div className="bg-dark-card rounded-lg p-8 shadow-xl">
            <div className="flex flex-col md:flex-row items-center md:items-start gap-8 mb-6">
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="flex-shrink-0"
              >
                <div className="w-48 h-48 md:w-56 md:h-56 rounded-full p-1 bg-gradient-to-r from-blue-500 to-purple-500 shadow-lg">
                  <img
                    src={profileImage}
                    alt={t('hero.name')}
                    className="w-full h-full rounded-full object-cover"
                  />
                </div>
              </motion.div>
              <div className="flex-1">
            <p className="text-lg text-gray-300 leading-relaxed mb-6">
                  {t('about.greeting')} <span className="text-white font-semibold">{t('about.name')}</span>{language === 'ko' ? '입니다.' : '.'}
            </p>
            <p className="text-lg text-gray-300 leading-relaxed mb-6">
                  {t('about.description1')}
            </p>
            
            <p className="text-lg text-gray-300 leading-relaxed">
                  <span className="text-white font-semibold">"{t('hero.motto')}"</span>{language === 'ko' ? '라는 신념으로' : ' - '}
                  {t('about.description2')}
            </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
